<template>
  <v-container class="py-8 primary-gradient-bg" fluid>
    <v-row class="py-8">
      <v-col cols="12" class="py-8">
        <template v-if="heroTitle === 'Samsung'">
          <v-img :src="require('../assets/samsung/Samsung_Orig_Wordmark_WHITE_RGB.jpg')"
                 max-width="160" class="mx-auto mb-5" alt="Samsung" title="Samsung"/>
        </template>
        <p class="white--text text-center">
          {{ $t(`${pageName}`) }}
        </p>
        <template v-if="heroTitle === 'Samsung'">
          <h1 style="font-family: 'Samsung Sharp', 'Samsung One', Helvetica, Arial, sans-serif !important; font-weight: 700;"
              class="text-center white--text" :class="$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2'">
            {{ $t(`${heroTitle}`) }}
          </h1>
        </template>
        <template v-else>
          <h1 class="text-center white--text" :class="$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2'">
            {{ $t(`${heroTitle}`) }}
          </h1>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'heroHeader',
  props: {
    pageName: String,
    heroTitle: String,
  },
};
</script>

<style scoped>

</style>
